<!--
 * @Desc: 
 * @Author: may.li
 * @Date: 2023-04-25 14:10:16
 * @LastEditors: lc
 * @LastEditTime: 2024-12-09 09:36:42
-->
<template>
  <div class="xingshi">
    <Button type="success"
            style="margin-bottom: 20px;"
            @click="addQiang">新增盲盒墙</Button>
    <Table :columns="tableList"
           :data="tableData"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <Modal v-model="showAdd"
           :title="isEdit ? '编辑' : '新增'"
           :loading="loading"
           @on-ok="confirmAddQiang('wangge')">
      <Form ref="wangge"
            :model="wangge"
            :rules="ruleWangge"
            action="javascript:void(0)"
            :label-width="120">
        <FormItem label="盲盒墙名称："
                  prop="name">
          <Input type="text"
                 v-model="wangge.name"
                 placeholder="请输入名称"></Input>
        </FormItem>
        <FormItem label="行数："
                  prop="line"
                  v-if="isEdit != 1">
          <Input type="number"
                 v-model="wangge.line"
                 number
                 placeholder="请输入行数"></Input>
        </FormItem>
        <FormItem label="列数："
                  prop="column"
                  v-if="isEdit != 1">
          <Input type="number"
                 v-model="wangge.column"
                 number
                 placeholder="请输入列数"></Input>
        </FormItem>
        <FormItem label="地址："
                  prop="position">
          <Input type="text"
                 v-model="wangge.position"
                 placeholder="请输入地址"></Input>
        </FormItem>
        <FormItem label="类型"
                  label-position="top">
          <RadioGroup v-model="wangge.type">
            <Radio label="1">A面</Radio>
            <Radio label="2">B面</Radio>
          </RadioGroup>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>
<script>
export default {
  data () {
    return {
      isEdit: 0, // 0新增 1编辑
      itemId: null,
      pages: {
        page: 1,
        size: 10
      },
      dataloading: true,
      loading: true,
      ruleWangge: {
        name: [
          { type: 'string', required: true, message: '名称必须填写', trigger: 'blur' }
        ],
        line: [
          { type: 'number', required: true, message: '行数必须填写,且不得小于1', validator: (rule, value) => value >= 1, trigger: 'blur' }
        ],
        column: [
          { type: 'number', required: true, message: '列数必须填写,且不得小于1', validator: (rule, value) => value >= 1, trigger: 'blur' }
        ],
        position: [
          {
            type: 'string', required: true, message: '地址必须填写', trigger: 'blur'
          }
        ]
      },
      wangge: {
        name: null,
        line: null,
        column: null,
        position: null,
        type: "1"
      },
      showAdd: false,
      tableData: [],
      tableList: [
        {
          title: 'id',
          key: 'id',
          width: 100,
        },
        {
          title: '盲盒墙名称',
          key: 'name'
        },
        {
          title: '尺寸',
          key: 'size',
          render: (h, params) => {
            return h('div', {}, params.row.line + '*' + params.row.column)
          }
        },
        {
          title: '地址',
          key: 'position'
        },
        {
          title: '类型',
          key: 'typename',
        },
        {
          title: '状态',
          key: 'status',
          render: (h, params) => {
            return h('i-switch', {
              props: {
                value: params.row.status == 1 ? true : false, // 1开 0关
              },
              on: {
                "on-change": value => {
                  this.changeStatus(params.row.id, value);
                }
              }
            },)
          }
        },
        {
          title: '操作',
          key: 'action',
          width: 260,
          fixed: 'right',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                style: {
                  marginRight: '8px'
                },
                props: {
                  type: 'success',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.ediItem(params.row.id)
                  }
                }
              }, '编辑'),
              h('Button', {
                style: {
                  marginRight: '8px'
                },
                props: {
                  type: 'primary',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.toBiaoge(params.row.id)
                  }
                }
              }, '配置盲盒墙'),
              h('Button', {
                style: {
                  marginRight: '8px'
                },
                props: {
                  type: 'error',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.delItem(params.row.id)
                  }
                }
              }, '删除')
            ])
          },
        }
      ],
    }
  },
  components: {

  },
  created () {
    this.renderTable(1);
  },
  methods: {
    handleBeforeChange () {
      console.log('handleBeforeChange')
    },
    /**
     * @name: 修改可用状态
     * @param {*} id
     * @param {*} value
     * @return {*}
     * @desc: 
     */
    changeStatus (id, value) {
      let params = {
        id: id,
        status: value
      };
      this.dataloading = true;
      this.$api.baixingqiang.areastatus(params).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.$Message.success(res.msg);
        } else {

          this.getTableList();
        }
      })
    },
    /**
     * @name: 删除
     * @param {*} id
     * @return {*}
     * @desc: 
     */
    delItem (id) {
      this.$Modal.confirm({
        title: "警告",
        content: "<p>是否确定删除？</p>",
        onOk: () => {
          this.$api.baixingqiang.arearemove({ id: id }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              this.getTableList();
            }
          })
        }
      })
    },
    /**
     * @name: 编辑列表
     * @param {*} id
     * @return {*}
     * @desc: 
     */
    ediItem (id) {
      this.showAdd = true;
      this.isEdit = 1;
      this.itemId = id;
      this.wangge.name = null;
      this.wangge.position = null;
      this.$api.baixingqiang.areadetail({ id: id }).then(res => {
        if (res.code == 200) {
          let info = res.result;
          this.wangge.name = info.name;
          this.wangge.type = info.type.toString();
          this.wangge.position = info.position;
        }
      })
    },
    /**
     * @name: 拉取数据
     * @param {*} page
     * @return {*}
     * @desc: 
     */
    renderTable (page) {
      this.pages.page = page;
      this.getTableList();
    },
    /**
     * @name: 翻页
     * @return {*}
     * @desc: 
     */
    changePage () {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(this.pages.page);
    },
    /**
     * @name: 获取列表
     * @return {*}
     * @desc: 
     */
    getTableList () {
      let params = {
        page: this.pages.page,
        size: this.pages.size
      };
      this.tableData = [];
      this.dataloading = true;
      this.$api.baixingqiang.arealist(params).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tableData = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      })
    },
    /**
     * @name: 控制loading
     * @return {*}
     * @desc: 
     */
    changeLoading () {
      this.loading = false;
      this.$nextTick(() => {
        this.loading = true;
      });
    },
    /**
     * @name: 新增&编辑盲盒墙
     * @return {*}
     * @desc: 
     */
    confirmAddQiang (name) {
      this.$refs[name].validate((vaild) => {
        if (vaild) {
          if (this.itemId) {
            // 编辑
            let params = {
              id: this.itemId,
              name: this.wangge.name,
              position: this.wangge.position,
              type: this.wangge.type,
            };
            this.$api.baixingqiang.areaedit(params).then(res => {
              if (res.code == 200) {
                this.changeLoading();
                this.showAdd = false;
                this.getTableList();
              }
            })
          } else {
            // 新增
            let params = this.wangge;
            this.$api.baixingqiang.areacreate(params).then(res => {
              if (res.code == 200) {
                this.changeLoading();
                this.showAdd = false;
                this.renderTable(1);
              }
            })
          }
        } else {
          return this.changeLoading();
        }
      })
    },
    /**
     * @name: 新增盲盒墙
     * @return {*}
     * @desc: 
     */
    addQiang () {
      this.isEdit = 0;
      this.itemId = null;
      this.showAdd = true;
      this.wangge = {
        name: null,
        line: null,
        column: null,
        position: null,
        type: "1"
      };
    },
    /**
     * @name: 去表格墙
     * @param {*} id
     * @return {*}
     * @desc: 
     */
    toBiaoge (id) {
      console.log('id', id)
      this.$router.push({
        path: '/baijiaxing/biaoge',
        query: {
          id: id
        }
      })
    }
  }
}
</script>
